import LoginResetPassPage from "@/views/LoginResetPass.vue";
import RecoverView from "@/views/users/Recover.vue";
import RegisterView from "@/views/users/Register.vue";

export default [
    {
        path: "/forgot",
        name: "LoginForgotPass",
        component: RecoverView,
        meta: {
            allowUnauthorized: true,
        },
    },
    {
        path: "/reset-pass",
        name: "LoginResetPass",
        component: LoginResetPassPage,
        props: route => ({ code: route.query.code }),
        meta: {
            allowUnauthorized: true,
        },
    },
    {
        path: "/register",
        name: "Register",
        component: RegisterView,
        props: true,
        meta: {
            allowUnauthorized: true,
        },
    },
    {
        path: "/create",
        name: "CreateNewUser",
        component: RegisterView,
        props: true,
        meta: {
            allowUnauthorized: true,
        },
    },
];
